import Handlebars from "../handlebars/handlebars";
import "./heroCarousel.css"
import heroCarouselHtml from "./heroCarousel.hbs"

const heroCarousel  = document.querySelector('.js--element-heroCarousel');

const state = {
    ready: true,
    pageIndicator: "",
    cta: "",
    heading: "",
    bodyCopy: "",
    href: "",
    background: "",
    pages: "",
    playerTime: 8000,
    totalCarouselPages: 0,
    pageIndicators: [],
    currentCarouselPage: 1,
    playHeroCarousel: '',
    heroCarouselContent: [
        {
            "heading": "FOIL PRINTING",
            "bodyCopy": "From shining accents to full floods, our foil Sleeking&trade; captivates every audience.",
            "buttonCpy": "Shop Foil Printing",
            "buttonLnk": "/shop/foil-printing",
            "background": "https://spdc-assets.imgix.net/images/homepage_foil.gif?w=900&h=500&auto=format,compressed",  
            "isCurrent": true
        },
        {
            "heading": "RAISED UV PRINTING",
            "bodyCopy": "Give your marketing 3D texture and transparent shine with raised UV printing.",
            "buttonCpy": "Shop Raised UV Printing",
            "buttonLnk": "/shop/raised-uv-printing",
            "background": "https://spdc-assets.imgix.net/images/homepage_raised-uv_perenne.gif?w=900&h=500&auto=format,compressed",  
            "isCurrent": false
        },
        {
            "heading": "CUSTOM BOOKLETS",
            "bodyCopy": "Print Custom Booklets for Catalogs, Manuals & more.",
            "buttonCpy": "Shop Booklets",
            "buttonLnk": "/shop/custom-booklets",
            "background": "https://spdc-assets.imgix.net/images/hero-carousel-booklets.jpg",  
            "isCurrent": false
        },
        {
            "heading": "FULL SERVICE DIRECT MAIL",
            "bodyCopy": "Send Direct Mail with complete fulfillment services.",
            "buttonCpy": "Shop Direct Mail",
            "buttonLnk": "/shop/direct-mail-printing",
            "background": "https://spdc-assets.imgix.net/images/hero-carousel-direct-mail.jpg",
            "isCurrent": false
        },
        {
            "heading": "CUSTOM BROCHURES",
            "bodyCopy": "Customize Brochures to elevate your brand & biz",
            "buttonCpy": "Shop Brochures",
            "buttonLnk": "/shop/brochure-printing",
            "background": "https://spdc-assets.imgix.net/images/hero-carousel-brochures.jpg", 
            "isCurrent": false
        }
    ]
};

function initHeroCarousel(){
    state.ready = true;
    state.totalCarouselPages = state.heroCarouselContent.length;
    setPage(state.currentCarouselPage);
    renderCarousel();
    state.playHeroCarousel = setInterval(playCarousel, state.playerTime);
    enableUI();
};

initHeroCarousel();

function setPage(page){
    state.pageIndicator = state.currentCarouselPage+"/"+state.totalCarouselPages;
    state.heading = state.heroCarouselContent[page-1].heading;
    state.bodyCopy = state.heroCarouselContent[page-1].bodyCopy;
    state.cta = state.heroCarouselContent[page-1].buttonCpy;
    state.href = state.heroCarouselContent[page-1].buttonLnk;
    state.background = state.heroCarouselContent[page-1].background;

    if(state.heroCarouselContent[page-1].bodyCopy) {
        state.bodyCopy = state.heroCarouselContent[page-1].bodyCopy;
    };
};

function setCurrent(){
        state.heroCarouselContent.forEach( e => {
        e.isCurrent = false;
    });
    state.heroCarouselContent[state.currentCarouselPage - 1].isCurrent = true;
}

function prevPage(){
    state.currentCarouselPage === 1 ? state.currentCarouselPage = state.totalCarouselPages : state.currentCarouselPage--;
    playCarousel();
};

function enableUI(){
    document.querySelector('.js--element-heroCarousel').addEventListener('click', handleClicks);
}

function handleClicks(e){
    if (e.target.matches('.js--action--heroCarouselNext')) {
        nextPage();
        return;
    }
    if (e.target.matches('.js--action--heroCarouselPrev')) {
        prevPage();
        return;
    }
}

function nextPage(){
    state.currentCarouselPage === state.totalCarouselPages ? state.currentCarouselPage = 1 : state.currentCarouselPage++;
    playCarousel();
};

function renderCarousel(){
    heroCarousel.innerHTML =  heroCarouselHtml(state);
};

function playCarousel(){
    setPage(state.currentCarouselPage);
    setCurrent();
    renderCarousel();
    clearInterval(state.playHeroCarousel);
    state.playHeroCarousel = setInterval(nextPage, state.playerTime);
};